import React from 'react';
import classnames from 'classnames';
import { CTAProps } from './models';
import './CTAButton.scss';

export const CTAComponent: React.FC<CTAProps> = ({
  text,
  href,
  target,
  style,
  svgContent,
  suffixIcon,
  accessibilityLabel,
  className,
  onClick,
}) => {
  // Determine if this should render as a link style vs CTA button style
  const isLinkStyle = style === 'link-cta';
    
  // Handle click events with analytics
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(event);
    }

  };

  // Build CSS classes
  const cssClasses = classnames(
    isLinkStyle ? 'cmp-link' : 'cmp-button',
    style,
    className
  );

  return (
    <a
      className={cssClasses}
      href={href}
      target={target}
      aria-label={accessibilityLabel || text}
      onClick={handleClick}
    >
      {/* Prefix Icon */}
      {svgContent && !suffixIcon && (
        <span className={isLinkStyle ? 'cmp-link__icon' : 'cmp-button__icon'} dangerouslySetInnerHTML={{ __html: svgContent }}/>
      )}
      
      {/* Text Content */}
      <span className={isLinkStyle ? 'cmp-link__text text-paragraph-s' : 'cmp-button__text'}>
        {text}
      </span>
      
      {/* Suffix Icon */}
      {svgContent && suffixIcon && (
        <span className={isLinkStyle ? 'cmp-link__icon' : 'cmp-button__icon'} dangerouslySetInnerHTML={{ __html: svgContent }}>
        </span>
      )}
    </a>
  );
};

// Export default
export default CTAComponent;